import React from "react";
import HeadTittle from "../../../../components/HeadTittle";
import DivContainerBody from "../../../../components/DivContainerBody";
import StepperTabs from "../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../components/StepperTabs/StepTab";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../../components/buttons/IconButtons";
import {ButtonNextStep, ButtonPrevStep} from "../../../../components/buttons/ButtonNavigation";
import {ZONE_ACCESS_STEP_LABELS, ZONE_ACCESS_STEPS, ZONE_ACCESS_UPDATE_TAB_LABELS} from "../Model/Model";
import ZoneAccessFormApp from "../Functionality/ZoneAccessFormApp";
import ZoneStep from "./Steps/ZoneStep";
import GuardStep from "./Steps/GuardStep";
import SummaryStep from "./Steps/SummaryStep";

/**
 * Creation of a zone access as a stepper, and its update with the zones and the guards as tabs.
 */
const ZoneAccessForm = () => {
    const {
        t,
        id,
        isUpdate,
        canSave,
        disabled,
        loaded,
        activeStep,
        setActiveStep,
        name,
        setName,
        selectedZones,
        setSelectedZones,
        selectedGuards,
        setSelectedGuards,
        assignedZones,
        removeAssignedZones,
        assignedGuards,
        removeAssignedGuards,
        emptyFields,
        handleNext,
        handleBack,
        handleClearFields,
        handleSave,
        goBackToList,
    } = ZoneAccessFormApp();

    const labels = (isUpdate ? ZONE_ACCESS_UPDATE_TAB_LABELS : ZONE_ACCESS_STEP_LABELS).map((label) => t(label));

    return (
        <>
            <HeadTittle onBack={goBackToList} name={isUpdate ? (disabled ? 'details' : 'update') : 'create'}>
                {isUpdate && canSave &&
                    <ButtonAction
                        id='btn_zaf_update'
                        name={'update'}
                        className={'btn-icon-edit'}
                        Icon={EditIcon}
                        onClick={handleSave}
                    />
                }
            </HeadTittle>

            <DivContainerBody>
                <StepperTabs
                    onlyTab={isUpdate}
                    disabled={false}
                    steps={labels}
                    activeStep={activeStep}
                    isStepOptional={(step) => step === ZONE_ACCESS_STEPS.GUARDS}
                    setActiveStep={setActiveStep}
                    handleStepChange={setActiveStep}
                >
                    <StepTab index={ZONE_ACCESS_STEPS.ZONES} activeStep={activeStep} normalHeight={true}>
                        {/* Mounted only while visible, so it opens on its first sub-tab as the guards do */}
                        {activeStep === ZONE_ACCESS_STEPS.ZONES && loaded &&
                            <ZoneStep
                                zoneAccessId={id}
                                isUpdate={isUpdate}
                                name={name}
                                setName={setName}
                                selectedZones={selectedZones}
                                setSelectedZones={setSelectedZones}
                                assignedZones={assignedZones}
                                removeAssignedZones={removeAssignedZones}
                                canSave={canSave}
                                disabled={disabled}
                                emptyFields={emptyFields}
                                handleClearFields={handleClearFields}
                            />
                        }
                        {!isUpdate &&
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mt-3'>
                                <ButtonNextStep id='btn_zaf_next_zones' text='next' click={handleNext}/>
                            </div>
                        }
                    </StepTab>
                    <StepTab index={ZONE_ACCESS_STEPS.GUARDS} activeStep={activeStep} normalHeight={true}>
                        {/* Mounted only while visible, so the list height is measured on a shown tab */}
                        {activeStep === ZONE_ACCESS_STEPS.GUARDS && loaded &&
                            <GuardStep
                                zoneAccessId={id}
                                isUpdate={isUpdate}
                                selectedGuards={selectedGuards}
                                setSelectedGuards={setSelectedGuards}
                                assignedGuards={assignedGuards}
                                removeAssignedGuards={removeAssignedGuards}
                                canSave={canSave}
                                disabled={disabled}
                            />
                        }
                        {!isUpdate &&
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep id='btn_zaf_back_guards' text='back' click={handleBack}/>
                                <ButtonNextStep id='btn_zaf_next_guards' text='next' click={handleNext}/>
                            </div>
                        }
                    </StepTab>
                    {!isUpdate &&
                        <StepTab index={ZONE_ACCESS_STEPS.SUMMARY} activeStep={activeStep} normalHeight={true}>
                            <SummaryStep
                                name={name}
                                selectedZones={selectedZones}
                                selectedGuards={selectedGuards}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep id='btn_zaf_back_summary' text='back' click={handleBack}/>
                                {canSave &&
                                    <ButtonNextStep id='btn_zaf_confirm' text='confirm' click={handleSave}/>
                                }
                            </div>
                        </StepTab>
                    }
                </StepperTabs>
            </DivContainerBody>
        </>
    );
};

export default ZoneAccessForm;
